<template>
  <ContextMenu :id="id" :items="menu" align="right" />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";

export default {
  mixins: [ContextMenuMixin],

  props: {
    section: { type: String, default: "training" },
  },

  computed: {
    routeParam() {
      return { user: this.item.id };
    },
    menu() {
      var menu = [
        {
          label: "View Details",
          action: () => {
            this.showDetailsPane();
          },
        },
        {
          label: "View Hours",
          action: () => {
            this.showHoursModal();
          },
        },
        {
          label: "View Training",
          action: () => {
            this.goToRoute(`${this.section}.users.history.index`, {
              user: this.item.id,
              type: "online",
            });
          },
        },
      ];

      if (this.$root.isAdmin && this.item.trainer_type === "EXTERNAL") {
        menu.push({
          label: "View Calendar",
          action: () => {
            let r = this.route("profile.calendar.index", {
              trainer: this.item.id
            });
            console.log(r);

            this.goToRoute("profile.calendar.index", {
              trainer: this.item.id
            });
          }
        })
      }
      if (!!this.item.is_writein && this.$root.isAdminager) {
        if (!this.item.is_active) {
          menu.push({
            label: "Activate Write-In",
            action: () => {
              this.changeWriteInStatus(true);
            },
          });
        } else {
          menu.push({
            label: "De-activate Write-In",
            action: () => {
              this.changeWriteInStatus(false);
            },
          });
        }
      }
      if (!!this.item.can_update) {
        var label = this.item.id == this.$root.user.id ? "My Profile" : "Edit";
        var route = this.$root.isAdmin
          ? "admin.users.edit"
          : "training.users.show";
        menu.push({
          label: label,
          action: () => {
            this.goToRoute(route, this.routeParam);
          },
        });
      }
      if (!!this.item.can_delete && this.section === "admin") {
        menu.push({
          label: "Remove",
          action: () => {
            this.delete();
          },
        });
      }
      if (!!this.item.can_portray && this.section === "admin") {
        menu.push({
          label: "Portray User",
          action: () => {
            window.location = `/?portray=${this.item.id}`;
          },
        });
      }
      menu.sort(this.sortMenu);
      return menu;
    },
  },

  methods: {
    showHoursModal() {
      this.$modal("HoursModal", { user: this.item })
        .then(() => {})
        .catch(() => {});
    },
    delete() {
      var confirmMessage = `Are you sure you would like to remove: "${this.item.first_name} ${this.item.last_name}"?`;
      if (confirm(confirmMessage)) {
        this.axios
          .delete(this.route("admin.users.destroy", this.routeParam))
          .then(() => {
            var message = `"${this.item.first_name} ${this.item.last_name}" has been removed`;
            this.eventBus.$emit("show-alert", "success", message, true);
            this.eventBus.$emit("refresh");
          });
      }
    },
    changeWriteInStatus(active) {
      var routeName = !!active
        ? "training.users.activate"
        : "training.users.deactivate";
      this.axios.post(this.route(routeName, this.routeParam)).then(() => {
        var message = `The write-in record for "${this.item.name}" has been successfully `;
        message += !!active ? "ACTIVATED" : "DE-ACTIVATED";
        this.eventBus.$emit("show-alert", "success", message, true);
        this.eventBus.$emit("refresh");
      });
    },
  },
};
</script>